























import { Component, Prop, Vue } from "vue-property-decorator";
import { CommentType, PostClass } from "../../../types";

import Comment from "./Comment.vue";
import { getAllComments } from "../../../helpers/comment-getter";

@Component({
  components: { Comment },
})
export default class CommentsList extends Vue {
  @Prop() private post!: PostClass;

  private are_all_comments_shown = false;

  mounted() {
    this.are_all_comments_shown = !(this.post.comments_number > 1);
  }

  showAllComments() {
    getAllComments(this.post.id).then(
      (comments) => (this.post.comments = comments)
    );
    this.are_all_comments_shown = true;
  }

  deleteComment(comment_key_in_array: number) {
    this.post.comments.splice(comment_key_in_array, 1);
  }
}
